import Backbone from 'backbone';
import _ from 'underscore';
import $ from 'jquery';
import AlertPopinView from './AlertPopinView';
import AlertChangeMailPopinView from './AlertChangeMailPopinView';
import AlertMailModel from '../../models/alerts/AlertMailModel';
import AlertContactModel from '../../models/alerts/AlertContactModel';
import AlertActivationModel from '../../models/alerts/AlertActivationModel';
import AccountAlertPopinTemplate from '../../../../templates/AccountAlertPopin.mustache';
import { isMobile } from '../../../common/others/Configuration';
import SharedDispatcher from '../../../common/others/SharedDispatcher';
import MailAlertingHeaderTemplate from '../../../../../../www/Account/Core/Alerting/_MailAlertingHeader.mustache';
import PhoneAlertingHeaderTemplate from '../../../../../../www/Account/Core/Alerting/_PhoneAlertingHeader.mustache';
import NumberUsageAlertingHeaderTemplate from '../../../../../../www/Account/Locale/Core/fr-FR/FnacCom/Alerting/_NumberUsageAlertingHeader.mustache';
import { MagnificPopup } from '../../../common/dynamic-imports/MagnificPopup';

import 'component?js-PopupInline';

export default Backbone.View.extend({
  renderOptions: {
    expandAlerts: false,
    reduceAlerts: false,
    hideManageInterestsButton: false,
    showMailAlertingOutput: false,
  },
  errors: [],
  smsPanelIsExpended: false,
  interestListIsExpended: false,
  saveCellPhoneBeforeActivation: false,

  events: {
    'change .js-MailAlerting-interestListItem--selector': 'addOrRemoveMailAlert',
    'click .js-MailAlerting-manageInterests': 'manageInterests',
    'click .js-PhoneAlerting-optIn': 'activateSMSAlert',
    'click .js-NumberUsageAlerting-optIn': 'activatePhoneAlert',
    'click .js-MailAlerting-optIn': 'activateMailAlert',
    'click .js-PhoneAlerting-updateCellPhone': 'showCellPhonePanelHandler',
    'click .js-PhoneAlerting-submit': 'saveCellPhoneNumber',
    'click .js-PhoneAlerting-optOut': 'optOutPhoneHandler',
    'click .js-NumberUsageAlerting-optOut': 'optOutNumberUsageHandler',
    'click .js-MailAlerting-optOut': 'optOutMailHandler',
    'click .js-interestDetails': 'displayInterestDetails',
    'click .js-ChangeMailButton': 'displayChangeEmailPopup',
  },

  initialize: function () {
    this._magnificPopup = new MagnificPopup();

    this.onResize = this.onResize.bind(this);
    this.displayChangeEmailPopup = this.displayChangeEmailPopup.bind(this);
    this.optOutMailRestrictHandler = this.optOutMailRestrictHandler.bind(this);
    this.optOutMailConfirmHandler = this.optOutMailConfirmHandler.bind(this);

    this._initializeSelectors();
    this._getMailPanelHeightAndThenHide();
    this._initModel();

    this.listenTo(SharedDispatcher, 'MailAlert:add', this.addAlert);
    this.listenTo(SharedDispatcher, 'MailAlert:remove', this.removeAlert);

    $(window).resize(this.onResize);
  },

  _initModel: function () {
    this.mailAlertModel = new AlertMailModel();
    this.alertContactModel = new AlertContactModel();
    this.alertActivationModel = new AlertActivationModel();

    var $smsInput = this.$el.find('.js-smsInput');
    if ($smsInput.length) {
      this.alertContactModel.validationOptions.cellPhoneRegex = $smsInput.data('val-regex-pattern');
      this.alertContactModel.validationOptions.cellPhoneRegexError = $smsInput.data('val-regex');
    }

    this.listenTo(this.alertContactModel, 'invalid', this.render);
  },

  _initializeSelectors: function () {
    this.$mailAlertingInterestsList = this.$el.find('.js-MailAlerting-interestsList');
    this.$phoneAlertingCellPhoneEditor = this.$el.find('.js-PhoneAlerting-cellPhoneEditor');
    this.$mailAlertingHeaderContainer = this.$el.find('.js-MailAlerting-headerContainer');
    this.$phoneAlertingHeaderContainer = this.$el.find('.js-PhoneAlerting-headerContainer');
    this.$numberUsageAlertingHeaderContainer = this.$el.find('.js-NumberUsageAlerting-headerContainer');
    this.$phoneAlertingCellPhoneEditorErrorsList = this.$phoneAlertingCellPhoneEditor.find(
      '.js-PhoneAlerting-cellPhoneEditor--errorsList'
    );
  },

  // HACK: Permet de récupèrer au load de la page la hauteur du bloc
  // pour pouvoir utiliser une animation par la suite. Aprés avoir récupéré la hauteur on cache les éléments.
  _getMailPanelHeightAndThenHide: function () {
    this.containerHeight = this.$mailAlertingInterestsList.height();
    this.containerPortable = this.$phoneAlertingCellPhoneEditor.height() + 12;
    this.$mailAlertingInterestsList.css('height', '0');
    this.$phoneAlertingCellPhoneEditor.css('height', '0');
  },

  optOutPhoneHandler: function (e) {
    e.preventDefault();
    this.alertActivationModel.save(
      {
        id: this.alertActivationModel.alertingType.Phone,
        AlertingLevel: this.alertActivationModel.alertingLevel.Optout,
      },
      {
        success: (model) => {
          this.reduceCellPhoneEditor();
          this.render(model);
        },
        error: this.manageErrorWithRedirection,
      }
    );
  },

  optOutNumberUsageHandler: function (e) {
    e.preventDefault();
    this.alertActivationModel.save(
      {
        id: this.alertActivationModel.alertingType.UseMyPhoneNumber,
        AlertingLevel: 0,
      },
      {
        success: (model) => {
          this.render(model);
        },
        error: this.manageErrorWithRedirection,
      }
    );
  },

  optOutMailHandler: function (e) {
    e.preventDefault();
    this._magnificPopup.open({
      items: { src: '#Unsubscribe' },
      callbacks: {
        open: () => {
          var $popinContent = $(this._magnificPopup.instance.content);
          $popinContent.on('click', '.js-MailAlerting-restrict--confirm', this.optOutMailRestrictHandler);
          $popinContent.on('click', '.js-MailAlerting-optOut--confirm', this.optOutMailConfirmHandler);
        },
        close: () => {
          var $popinContent = $(this._magnificPopup.instance.content);
          $popinContent.off('click', '.js-MailAlerting-restrict--confirm', this.optOutMailRestrictHandler);
          $popinContent.off('click', '.js-MailAlerting-optOut--confirm', this.optOutMailConfirmHandler);
        },
      },
    });
  },

  optOutMailConfirmHandler: function (e) {
    e.preventDefault();
    this.alertActivationModel.save(
      {
        id: this.alertActivationModel.alertingType.Mail,
        AlertingLevel: this.alertActivationModel.alertingLevel.Optout,
      },
      {
        success: (model) => {
          this._magnificPopup.close();
          this.$el.find('.js-MailAlerting-interestListItem--selector').prop('checked', false);
          this.renderOptions.reduceAlerts = true;
          this.reduceCellPhoneEditor();
          this.render(model);
        },
        error: this.manageErrorWithRedirection,
      }
    );
  },

  optOutMailRestrictHandler: function (e) {
    e.preventDefault();
    this._magnificPopup.close();
    this.reduceCellPhoneEditor();
    this.renderOptions.reduceAlerts = true;
  },

  openPartnerUrl: function ($currentTarget) {
    var $item = $currentTarget.parent('.js-MailAlerting-interestListItem');
    if ($item.length) {
      var partnerUrl = $item.data('partner-url');
      if (partnerUrl && partnerUrl !== '') {
        $currentTarget.prop('checked', false);
        window.open(partnerUrl, '_blank');
      }
    }
  },

  displayInterestDetails: function (e) {
    e.preventDefault();

    var $currentTarget = $(e.currentTarget);
    var $parent = $currentTarget.parent('li');

    this.openPartnerUrl($currentTarget);
    var jsonObject = $parent.data('object');
    if (jsonObject) {
      this.openAlertPopin(jsonObject);
    }
  },

  displayChangeEmailPopup: function (e) {
    e.preventDefault();
    this._magnificPopup.open({
      items: {
        src: '<div class="ma-alertPopin"></div>',
        type: 'inline',
        showCloseBtn: true,
      },
      callbacks: {
        open: () => {
          var $popinContent = $('<div></div>');
          $(this._magnificPopup.instance.content).append($popinContent);

          this.alertPopin = new AlertChangeMailPopinView({
            el: $popinContent[0],
            alertContactModel: this.alertContactModel,
            content: this.$el.find('#ChangeMail'),
          });
        },
        afterClose: () => {
          this.alertPopin.remove();
          this.$el.find('.js-EmailAddressLabel').text(this.alertContactModel.id);
          this.$el.find('#EmailAddress').attr('value', this.alertContactModel.id);
        },
      },
    });
  },

  showCellPhonePanelHandler: function (e) {
    e.preventDefault();
    this.expandCellPhoneEditor();
  },

  saveCellPhoneNumber: function (e) {
    e.preventDefault();
    this.clearErrors();

    this.errors = [];
    var $cellPhoneInput = this.$el.find('#CellPhone');
    var cellPhoneValue = $cellPhoneInput.val();

    if ($cellPhoneInput.length) {
      this.alertContactModel.updateCellPhoneNumber(cellPhoneValue, {
        success: (model, response) => {
          if (this.saveCellPhoneBeforeActivation) {
            this.saveCellPhoneBeforeActivation = false;
            this.activateSMSAlert();
          } else {
            var $label = this.$el.find('.js-CellPhoneNumberLabel');
            if ($label.length) {
              $label.text(cellPhoneValue);
            }
            this.reduceCellPhoneEditor();
          }
        },
        error: (model, response, error) => {
          this.manageErrorWithRedirection(model, response);
          if (response.status === 400) {
            const messages = response.responseJSON.CellPhone;
            this.errors.push(messages);
            this.render();
          }
        },
      });
    }
  },

  clearErrors: function () {
    this.$phoneAlertingCellPhoneEditorErrorsList.empty();
  },

  displayErrors: function () {
    if (this.errors.length) {
      this.$phoneAlertingCellPhoneEditorErrorsList.append(this.errors[0]);
    }

    this.$phoneAlertingCellPhoneEditor.css('height', 'auto');
  },

  openAlertPopin: function (data) {
    var templateRendered = AccountAlertPopinTemplate.render(data);
    if (templateRendered && templateRendered !== '') {
      this._magnificPopup.open({
        items: {
          src: templateRendered,
          showCloseBtn: true,
        },
        callbacks: {
          open: () => {
            this.alertPopin = new AlertPopinView({
              el: this._magnificPopup.instance.content,
              interest: data,
            });
          },
        },
      });
    }
  },

  addAlert: function (e) {
    this.mailAlertModel.save(
      { id: e.id },
      {
        success: () => {
          this.updateInterestData({ data: e, selected: true });
        },
        error: this.manageErrorWithRedirection,
      }
    );
  },

  removeAlert: function (e) {
    this.mailAlertModel.set({ id: e.id });
    this.mailAlertModel.destroy({
      success: () => {
        this.updateInterestData({ data: e, selected: false });
      },
      error: this.manageErrorWithRedirection,
    });
  },

  manageErrorWithRedirection: function (model, response, options) {
    if (response && response.status === 401) {
      var urlRedirect = options.xhr.getResponseHeader('location');
      document.location.href = urlRedirect;
    }
  },

  updateInterestData: function (obj) {
    var $element = this.$el.find('.js-MailAlerting-interestListItem--selector[data-id="' + obj.data.parentId + '"]');
    var $elementParent = $element.parent('li');

    var dataObject = $elementParent.data('object');

    const index = dataObject.Children.findIndex(({ Id }) => Id === obj.data.id);
    if (index >= 0) {
      dataObject.Children[index].Selected = obj.selected;
    }

    $elementParent.data('object', dataObject);

    $element.prop('checked', Boolean(dataObject.Children.find(({ Selected }) => Selected)));
  },

  addOrRemoveMailAlert: function (e) {
    e.preventDefault();

    var $currentTarget = $(e.currentTarget);
    var $parent = $currentTarget.parent('li');

    var jsonObject = $parent.data('object');
    if (jsonObject) {
      $currentTarget.prop('checked', !$currentTarget.prop('checked'));
      this.openAlertPopin(jsonObject);
      return;
    }

    if (e.currentTarget.checked) {
      this.openPartnerUrl($currentTarget);
    }

    var changedItem = e.currentTarget;
    this.mailAlertModel.set({ id: $(changedItem).data('id') });

    var options = {
      success: (model, response) => {
        this.renderOptions.hideManageInterestsButton = true;
        this.renderOptions.showMailAlertingOutput = true;
        this.render(model);
      },
      error: this.manageErrorWithRedirection,
    };

    if (changedItem.checked) {
      this.mailAlertModel.save({}, options);
    } else {
      this.mailAlertModel.destroy({
        wait: true,
        success: (model, response) => {
          this.mailAlertModel.changed.MailAlerting = response.MailAlerting;
          this.mailAlertModel.changed.PhoneAlerting = response.PhoneAlerting;

          this.renderOptions.hideManageInterestsButton = true;
          this.renderOptions.showMailAlertingOutput = true;
          this.render(this.mailAlertModel);
        },
        error: this.manageErrorWithRedirection,
      });
    }
  },

  onResize: function () {
    if (this.$mailAlertingInterestsList.css('height') !== '0px') {
      this.$mailAlertingInterestsList.css('height', 'auto');
    }
    if (this.$phoneAlertingCellPhoneEditor.css('height') !== '0px') {
      this.$phoneAlertingCellPhoneEditor.css('height', 'auto');
    }
  },

  manageInterests: function (e) {
    e.preventDefault();
    this.expandAlerts();
  },

  expandAlerts: function () {
    if (this.interestListIsExpended === false) {
      this.interestListIsExpended = true;
      this.$mailAlertingInterestsList.show();
      this.$mailAlertingInterestsList.css('opacity', '1');
      if (isMobile) {
        this.$mailAlertingInterestsList.css('height', this.containerHeight);
      } else {
        this.$mailAlertingInterestsList.animate({ height: this.containerHeight }, 500);
      }
      this.$el.find('.js-MailAlerting-manageInterests').addClass('hide');
      this.$el.find('.js-MailAlerting-optOut').removeClass('hide');
    }
  },

  reduceAlerts: function () {
    if (this.interestListIsExpended === true) {
      this.interestListIsExpended = false;
      this.$mailAlertingInterestsList.hide();
      this.$mailAlertingInterestsList.css('opacity', '0');
      if (isMobile) {
        this.$mailAlertingInterestsList.css('height', 0);
      } else {
        this.$mailAlertingInterestsList.animate({ height: 0 }, 500);
      }
      this.$el.find('.js-MailAlerting-optOut').addClass('hide');
    }
  },

  expandCellPhoneEditor: function () {
    this.smsPanelIsExpended = true;
    this.$phoneAlertingCellPhoneEditorErrorsList.empty();
    this.$phoneAlertingCellPhoneEditor.show();
    this.$phoneAlertingCellPhoneEditor.css('opacity', 1);
    if (isMobile) {
      this.$phoneAlertingCellPhoneEditor.css('height', this.containerPortable);
    } else {
      this.$phoneAlertingCellPhoneEditor.animate({ height: this.containerPortable }, 500);
    }
  },

  reduceCellPhoneEditor: function () {
    this.smsPanelIsExpended = false;
    this.$phoneAlertingCellPhoneEditorErrorsList.empty();
    this.$phoneAlertingCellPhoneEditor.animate({ height: 0 }, 500, () => {
      this.$phoneAlertingCellPhoneEditor.hide();
    });
  },

  activateSMSAlert: function (e) {
    if (e) {
      e.preventDefault();
    }

    var $smsInput = this.$el.find('.js-smsInput');
    var cellPhoneValue = $smsInput.val();

    if (cellPhoneValue === '') {
      this.saveCellPhoneBeforeActivation = true;
      this.expandCellPhoneEditor();
    } else {
      this.alertActivationModel.save(
        {
          id: this.alertActivationModel.alertingType.Phone,
          AlertingLevel: this.alertActivationModel.alertingLevel.Optin,
        },
        {
          success: (model) => {
            delete model.changed.MailAlerting;
            this.render(model);
          },
          error: this.manageErrorWithRedirection,
        }
      );
    }
  },

  activatePhoneAlert: function (e) {
    if (e) {
      e.preventDefault();
    }
    this.alertActivationModel.save(
      {
        id: this.alertActivationModel.alertingType.UseMyPhoneNumber,
        AlertingLevel: 1,
      },
      {
        success: (model) => {
          this.render(model);
        },
        error: this.manageErrorWithRedirection,
      }
    );
  },

  activateMailAlert: function (e) {
    e.preventDefault();

    this.alertActivationModel.save(
      {
        id: this.alertActivationModel.alertingType.Mail,
        AlertingLevel: this.alertActivationModel.alertingLevel.Optin,
      },
      {
        success: (model) => {
          this.renderOptions.expandAlerts = true;
          this.renderOptions.hideManageInterestsButton = true;
          this.render(model);
        },
        error: this.manageErrorWithRedirection,
      }
    );
  },

  render: function (model, error) {
    if (this.smsPanelIsExpended === true) {
      this.clearErrors();
      if (error) {
        this.errors.push(error);
      }
      if (this.errors.length > 0) {
        this.displayErrors();
        return;
      }
    }

    if (model) {
      if (model.changed.MailAlerting) {
        var mailAlertingHeaderRenderer = MailAlertingHeaderTemplate.render(model.changed.MailAlerting);
        this.$mailAlertingHeaderContainer.html(mailAlertingHeaderRenderer);

        if (this.renderOptions.hideManageInterestsButton === true) {
          this.renderOptions.hideManageInterestsButton = false;
          this.$el.find('.js-MailAlerting-manageInterests').addClass('hide');
        }

        var $optout = this.$el.find('.js-MailAlerting-optOut');
        if (this.renderOptions.showMailAlertingOutput === true) {
          this.renderOptions.hideManageInterestsButton = false;
          $optout.removeClass('hide');
        } else {
          $optout.addClass('hide');
        }

        if (this.renderOptions.expandAlerts === true) {
          this.renderOptions.expandAlerts = false;
          this.expandAlerts();
        } else if (this.renderOptions.reduceAlerts === true) {
          this.renderOptions.reduceAlerts = false;
          this.reduceAlerts();
        }

        delete model.changed.MailAlerting;
      }

      if (model.changed.PhoneAlerting) {
        var phoneAlertingHeaderRenderer = PhoneAlertingHeaderTemplate.render(model.changed.PhoneAlerting);
        var $phoneAlertingHtml = $(phoneAlertingHeaderRenderer);
        if ($phoneAlertingHtml.length) {
          this.$phoneAlertingHeaderContainer.html($phoneAlertingHtml);
        }

        if (model.changed.PhoneAlerting.OptIn && this.smsPanelIsExpended) {
          this.reduceCellPhoneEditor();
        }

        delete model.changed.PhoneAlerting;
      }

      if (model.changed.NumberUsageAlerting) {
        var numberUsageAlertingHeaderRenderer = NumberUsageAlertingHeaderTemplate.render(
          model.changed.NumberUsageAlerting
        );
        var $numberUsageAlertingHtml = $(numberUsageAlertingHeaderRenderer);

        if ($numberUsageAlertingHtml.length) {
          this.$numberUsageAlertingHeaderContainer.html($numberUsageAlertingHtml);
        }
        delete model.changed.NumberUsageAlerting;
      }
    }
  },
});
